import { Link } from 'react-router-dom';
import usePageAnimations from '../../hooks/usePageAnimations';

export default function AboutPage() {
  usePageAnimations('.about-hero, .story-photo, .story-copy, .ribbon-photo, .dresscode-heading, .dresscode-warning, .dresscode-guidance, .dresscode-adults figure, .about-section-heading, .about-details article, .about-actions');
  return (
    <div className="about-page">
      <header className="notebook-header">
        <Link to="/"><i className="ri-arrow-left-line" /> Voltar ao convite</Link>
        <img src="/assets/monograma-ysl.png" alt="Yasmin Siqueira" />
        <Link to="/galeria"><i className="ri-camera-line" /> Galeria</Link>
      </header>
      <main>
        <section className="about-hero">
          <span>MEUS 15 ANOS</span>
          <img src="/assets/assinatura-yasmin-horizontal.png" alt="Yasmin Siqueira XV" />
          <p>Uma noite sonhada com carinho para celebrar uma história que está apenas começando.</p>
        </section>

        <section className="yasmin-story">
          <div className="story-collage story-collage-left">
            <figure className="story-photo story-photo-main"><img src="/assets/galeria/foto-01.jpg" alt="Retrato de Yasmin" /></figure>
            <figure className="story-photo story-photo-small"><img src="/assets/galeria/foto-08.jpg" alt="Yasmin em um momento especial" /></figure>
            <span className="story-flourish">XV</span>
          </div>
          <div className="story-copy">
            <span>UM POUCO DA MINHA HISTÓRIA</span>
            <h1>A Yasmin</h1>
            <i />
            <p>Hoje celebramos muito mais do que uma festa; celebramos a realização de um sonho que foi cuidadosamente construído ao longo dos anos, cercado de amor, carinho, dedicação e muitas expectativas. Meus 15 anos marcam o início de uma nova etapa da minha vida, repleta de descobertas, aprendizados, desafios e momentos inesquecíveis.</p>
            <p>Cada sorriso, cada abraço, cada ensinamento e cada pessoa que fez parte da minha caminhada contribuíram para que este dia se tornasse ainda mais especial. Chegar até aqui é motivo de gratidão, e não poderia imaginar este momento sem a presença daqueles que sempre estiveram ao meu lado, compartilhando alegrias, apoiando meus sonhos e fazendo parte da minha história.</p>
            <p>Que esta celebração seja não apenas a comemoração dos meus 15 anos, mas também o início de uma jornada iluminada pelas bênçãos de Deus, repleta de sonhos, conquistas e felicidade. <b>✨💕🎂</b></p>
            <img src="/assets/assinatura-yasmin-horizontal.png" alt="Yasmin Siqueira XV" />
          </div>
        </section>

        <section className="story-photo-ribbon" aria-label="Momentos de Yasmin">
          {['13','18','24','30'].map((number, index) => <figure key={number} className={`ribbon-photo ribbon-photo-${index}`}><img src={`/assets/galeria/foto-${number}.jpg`} alt={`Momento especial de Yasmin ${index + 1}`} /></figure>)}
        </section>

        <section className="dresscode-section">
          <div className="dresscode-heading">
            <i className="ri-shirt-line" />
            <span>PARA CELEBRAR CONOSCO</span>
            <h2>Dress Code</h2>
            <strong>Traje Social Completo</strong>
            <p>Elegância e sofisticação para uma noite muito especial.</p>
          </div>

          <div className="dresscode-warning">
            <i className="ri-information-line" />
            <div><strong>Observação muito importante</strong><p>A cor <b>AZUL-MARINHO</b> está reservada para a debutante, sendo de uso exclusivo da Yasmin. Pedimos, com carinho, que os convidados escolham outras cores.</p></div>
          </div>

          <div className="dresscode-group">
            <p className="dresscode-guidance">Vestidos longos ou midi elegantes, ternos completos, gravata e sapatos sociais.</p>
            <div className="dresscode-adults">
              {['1','3'].map((number) => <figure key={number}><img src={`/assets/dresscode-adultos-${number}.png`} alt={`Inspirações de traje social completo para adultos ${number}`} /></figure>)}
            </div>
          </div>

        </section>

        <div className="about-section-heading"><i className="ri-sparkling-2-line"/><h2>Informações sobre a Festa</h2><p>Tudo foi preparado para vivermos juntos uma noite inesquecível</p></div>
        <section className="about-details">
          <article><i className="ri-calendar-2-line"/><div><small>DATA</small><h2>12 de setembro de 2026</h2><p>Sábado, às 20 horas</p></div></article>
          <article><i className="ri-map-pin-line"/><div><small>LOCAL</small><h2>Bisutti Zero Onze</h2><p>R. Alvorada, 1035<br/>Vila Olímpia — São Paulo / SP</p></div></article>
          <article><i className="ri-shirt-line"/><div><small>TRAJE</small><h2>Social Completo</h2><p>Escolha um look elegante e lembre-se: o azul-marinho é exclusivo da Yasmin.</p></div></article>
          <article><i className="ri-time-line"/><div><small>PROGRAMAÇÃO</small><h2>Uma noite inesquecível</h2><p>Recepção, cerimônia, jantar e muita música para comemorar.</p></div></article>
          <article className="about-age-notice"><i className="ri-forbid-2-line"/><div><small>ATENÇÃO</small><h2>Classificação etária</h2><p>Não é permitida a entrada de menores de 12 anos.</p></div></article>
        </section>
        <div className="about-actions"><Link to="/#localizacao">VER LOCALIZAÇÃO</Link><Link to="/galeria">VER GALERIA</Link></div>
      </main>
      <img className="about-rose about-rose-left" src="/assets/rosas-footer-transparentes.png" alt="" />
      <img className="about-rose about-rose-right" src="/assets/rosas-footer-transparentes.png" alt="" />
    </div>
  );
}
